// Wrapper Component for the Mantine Checkbox
import { ChangeEvent, ReactElement } from 'react';
import { Checkbox } from './Checkbox';

// Link to Mantine Checkbox Component:  https://mantine.dev/core/checkbox/
type Props = {
  checkboxes: {
    id?: string,
    label: string,
    isChecked: boolean,
    onChange: (e: ChangeEvent) => void,
  }[],
  color?: string,
}

export function CheckboxList({
  checkboxes,
  color,
}: Props): ReactElement {
  return (
    <>
      {checkboxes.map((checkbox) => (
        <Checkbox
          id={checkbox.id || checkbox.label}
          key={checkbox.label}
          label={checkbox.label}
          isChecked={checkbox.isChecked}
          onChange={(e) => checkbox.onChange(e)}
          color={color}
        />
      ))}
    </>
  );
}
